import { TemplateRef } from '@angular/core';

export interface Breakpoint {
  minWidth: number | null;
  maxWidth: number | null;
}

export enum BreakpointSize {
  small = 's',
  medium = 'm',
  large = 'l',
  extraLarge = 'xl',
}

export type BreakpointMap = { [key in BreakpointSize]?: TemplateRef<unknown> };
